<div *ngIf="!showMobileQr; else continueOnMobile">
	<div *ngIf="cafAuthentication$() | async">
		<obg-m-dialog-layout #dialog>
			<account-document_detector_caf />
		</obg-m-dialog-layout>
	</div>
</div>
<ng-template #continueOnMobile>
	<obg-m-dialog-layout #dialog>
		<account-continue-on-mobile_qr />
	</obg-m-dialog-layout>
</ng-template>
